import Helper from '@ember/component/helper';
import { formatNumber } from 'cio/helpers/format-number';
import { pluralize } from 'cio/helpers/pluralize';

export function formatNumberAndPluralize([number, word]) {
  return `${formatNumber([number])} ${pluralize([number, word])}`;
}
export default Helper.helper(formatNumberAndPluralize);
